
        import * as module0 from './controllers/scroll_progress_controller.js'
        const modules = {
            "./controllers/scroll_progress_controller.js": module0,
        };
        export default modules;
      